/* eslint-disable i18next/no-literal-string */

/**
 * Ported from bouncieweb's `LandingPageComponents/HumExplanation.js`.
 *
 * A centered white card that overlaps nothing but sits directly under the hero,
 * carrying the page's positioning statement.
 *
 * The original's subheader had a `fontsize: 16` typo (lowercase `s`), which
 * Emotion emitted as an unknown property and browsers dropped — so the 16px base
 * never applied and the text fell back to the inherited body size. The intended
 * `16px -> 18px at lg` ramp is reproduced here as `text-base lg:text-lg`, which
 * matches the inherited 16px base anyway.
 *
 * Original breakpoint map (theme/mediaQueries):
 *   xsm 431px -> min-[431px]:  sm 640px -> sm:  lg 1024px -> lg:  xlg 1280px -> xl:
 */

export default function HumExplanation() {
  return (
    // Wrapper
    <div className="flex justify-center bg-white px-4 sm:px-[50px]">
      {/* Container */}
      <div className="flex-[1_0_100%] rounded-[20px] bg-white p-8 shadow-[0px_0px_40px_#00000030] xl:max-w-[1400px] xl:px-4 xl:py-12">
        <div className="flex flex-col items-center text-center leading-[1.3]">
          {/* Header */}
          <h2 className="font-display mt-0 mb-[10px] max-w-[307px] text-[8vw] font-extrabold min-[431px]:max-w-none min-[431px]:text-[32px] lg:text-[32px]">
            Redefining Connected Driving for Hum Users
          </h2>
          {/* SubHeader */}
          <h3 className="font-display mt-0 mb-0 text-base font-extrabold lg:text-lg">
            Let&rsquo;s upgrade your connected car experience.
          </h3>
        </div>
      </div>
    </div>
  );
}
